const state = {
  users_list: [],
  picked: []
}

const getters = {
  usersCount: function(state) {
    return state.users_list.length
  },
  usersList: function(state) {
    return state.users_list
  },
  propertyTable: function(state){
    return state.picked
  }

}

const mutations = {
  table: function (state, selected) {
    state.picked = selected
  },
  loadUsers: function(state, users) {
    state.users_list = users
  },
  addUser: function(state, user) {
    state.users_list.push(user)
  },
  resetUsers: function(state) {
    state.users_list = []
  }
}

const actions = {
  resetUsers (context) {
    context.commit('resetUsers', [])
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/user.js